import React, { useContext, Suspense } from "react";
import { useParams } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTheme } from "@material-ui/core/styles";
import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";
import TicketsManagerTabs from "../../components/TicketsManagerTabs/";

const Ticket = React.lazy(() => import("../../components/Ticket/"));

const TicketAdvanced = () => {
  const { ticketId } = useParams();
  const theme = useTheme();
  const isDark = theme.palette.type === "dark";
  const hasTicket = ticketId && ticketId !== "undefined";

  return (
    <QueueSelectedProvider>
      <div style={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        height: "100%",
        minHeight: 0,
        overflow: "hidden",
        background: isDark ? "#111b21" : "#f0f2f5",
        position: "relative",
      }}>

        {/* ── LIST VIEW — always mounted, hidden when in chat ── */}
        <div style={{
          display: hasTicket ? "none" : "flex",
          flexDirection: "column",
          height: "100%",
          overflow: "hidden",
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        }}>
          {/* WhatsApp-style header */}
          <div style={{
            display: "flex",
            alignItems: "center",
            padding: "0 12px 0 16px",
            background: isDark ? "#1f2c34" : "#075e54",
            color: "#fff",
            height: 56,
            flexShrink: 0,
            boxShadow: "0 1px 4px rgba(0,0,0,0.35)",
          }}>
            <span style={{
              flex: 1,
              fontSize: 20,
              fontWeight: 700,
              letterSpacing: 0.3,
              color: "#fff",
            }}>
              Estratiza Hub
            </span>
          </div>

          {/* Tickets list with tabs/filters */}
          <div style={{
            flex: 1,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
          }}>
            <TicketsManagerTabs />
          </div>
        </div>

        {/* ── CHAT VIEW — full screen when ticket selected ── */}
        {hasTicket && (
          <div style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            overflow: "hidden",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: isDark ? "#0d1418" : "#efeae2",
          }}>
            <Suspense fallback={
              <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                background: isDark ? "#0d1418" : "#efeae2",
              }}>
                <CircularProgress style={{ color: "#25d366" }} />
              </div>
            }>
              <Ticket />
            </Suspense>
          </div>
        )}

      </div>
    </QueueSelectedProvider>
  );
};

export default TicketAdvanced;
